import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import get from 'lodash/get';

import ManualAddressForm, { ManualAddressFormProps } from './ManualAddressForm';

const mapStateToProps = (state, props: ManualAddressFormProps) => {
  const fieldName = props.name;

  return {
    [fieldName]:
      get(state, `reduxFormReducer.baoForms.values.${fieldName}`) ||
      get(state, `productFormReducer.baoForms.productForm.values.${fieldName}`),
  };
};

export default injectIntl<ManualAddressFormProps>(connect(mapStateToProps)(ManualAddressForm));
